var React = require('react');

function MobileNavIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_397","data-name":"Group 397","transform":"translate(-307 -36)"},[React.createElement("rect",{"id":"Rectangle_213","data-name":"Rectangle 213","width":"43","height":"3","transform":"translate(307 36)","fill":"#fff","key":0}),React.createElement("rect",{"id":"Rectangle_214","data-name":"Rectangle 214","width":"38","height":"3","transform":"translate(312 48)","fill":"#fff","key":1}),React.createElement("rect",{"id":"Rectangle_215","data-name":"Rectangle 215","width":"31","height":"3","transform":"translate(319 60)","fill":"#fff","key":2})]));
}

MobileNavIcon.defaultProps = {"width":"43","height":"27","viewBox":"0 0 43 27"};

module.exports = MobileNavIcon;

MobileNavIcon.default = MobileNavIcon;
